import { render, staticRenderFns } from "./PreliminaryReport.vue?vue&type=template&id=3f0983d8&"
import script from "./PreliminaryReport.vue?vue&type=script&lang=ts&"
export * from "./PreliminaryReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports